var map = {
	"./en/components.json": [
		71025,
		81
	],
	"./en/opengraph.json": [
		34998,
		380
	],
	"./en/translation.json": [
		32592,
		215
	],
	"./en/upskilling.json": [
		2847,
		789
	],
	"./en_UK/opengraph.json": [
		7385,
		151
	],
	"./en_UK/translation.json": [
		41001,
		722
	],
	"./en_UK/upskilling.json": [
		81404,
		909
	],
	"./fr/components.json": [
		32859,
		12
	],
	"./fr/translation.json": [
		74126,
		397
	],
	"./fr/upskilling.json": [
		71697,
		30
	],
	"./fr@tu/components.json": [
		62299,
		736
	],
	"./fr@tu/opengraph.json": [
		2845,
		244
	],
	"./fr@tu/upskilling.json": [
		29493,
		757
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 33437;
module.exports = webpackAsyncContext;